export type IrrigationTriggerSource = 'scheduled' | 'manual';
export type IrrigationEventStatus = 'running' | 'completed' | 'stopped_manual' | 'skipped';
export type IrrigationSkipReason = 'rain_forecast' | 'humidity_above_threshold' | 'weather_unavailable';

export interface IrrigationEvent {
  id: string;
  deviceId: string;
  valveChannel: number;
  scheduleId: string | null;
  triggerSource: IrrigationTriggerSource;
  status: IrrigationEventStatus;
  skipReason: IrrigationSkipReason | null;
  startedAt: string | null;
  endedAt: string | null;
  plannedDurationSeconds: number | null;
  estimatedLiters: number | null;
}

export const skipReasonLabel: Record<IrrigationSkipReason, string> = {
  rain_forecast: 'Se salteó: pronóstico de lluvia',
  humidity_above_threshold: 'Se salteó: humedad alta',
  weather_unavailable: 'Se salteó: no se pudo consultar el clima',
};

export interface IrrigationSchedule {
  id: string;
  deviceId: string;
  valveChannel: number;
  enabled: boolean;
  daysOfWeek: number[]; // 0=domingo .. 6=sábado
  startTime: string; // "HH:mm", hora de Argentina
  durationSeconds: number;
  flowRateLpm: number;
  rainSkipEnabled: boolean;
  rainSkipProbabilityPct: number;
  // Sonda de suelo que decide si saltear: estación + número de sonda.
  humidityDeviceId: string | null;
  humidityChannel: number | null;
  humiditySkipThresholdPct: number | null;
  notifyOnSkip: boolean;
}

// Una válvula de la estación con su estado (GET /devices/:id/valves).
export interface ValveSummary {
  componentId: string;
  channel: number;
  name: string;
  running: IrrigationEvent | null;
  lastFinished: IrrigationEvent | null;
  schedule: IrrigationSchedule | null;
}

export const DAY_LABELS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
